import { createAction } from 'redux-act';
//////////////////////////////////////////////////

export const getConfigsForCloConfigSuccess = createAction('getConfigsForCloConfigSuccess');
export const getAccessorialConfigListForCloConfigSuccess = createAction('getAccessorialConfigListForCloConfigSuccess');
// default order accessorials
export const removeDefaultOrderAccessorialRequest = createAction('removeDefaultOrderAccessorialRequest');
export const removeDefaultOrderAccessorialSuccess = createAction('removeDefaultOrderAccessorialSuccess');
export const getDefaultOrderAccessorialListRequest = createAction('getDefaultOrderAccessorialListRequest');
export const getDefaultOrderAccessorialListSuccess = createAction('getDefaultOrderAccessorialListSuccess');
export const createOrUpdateDefaultOrderAccessorialRequest =
  createAction('createOrUpdateDefaultOrderAccessorialRequest');
export const createOrUpdateDefaultOrderAccessorialSuccess =
  createAction('createOrUpdateDefaultOrderAccessorialSuccess');
// order type mapping
export const removeOrderTypeMappingByTypeSuccess = createAction('removeOrderTypeMappingByTypeSuccess');
export const removeOrderTypeMappingByTypeRequest = createAction('removeOrderTypeMappingByTypeRequest');
export const getOrderTypeMappingListByTypeSuccess = createAction('getOrderTypeMappingListByTypeSuccess');
export const getOrderTypeMappingListByTypeRequest = createAction('getOrderTypeMappingListByTypeRequest');
export const createOrUpdateOrderTypeMappingByTypeRequest = createAction('createOrUpdateOrderTypeMappingByTypeRequest');
export const createOrUpdateOrderTypeMappingByTypeSuccess = createAction('createOrUpdateOrderTypeMappingByTypeSuccess');
